const dataTypes = {
  GET_DATA_COUNT: "GET_DATA_COUNT",
  GET_DATA_COUNT_SUCCESS: "GET_DATA_COUNT_SUCCESS",
  GET_DATA_COUNT_FAIL: "GET_DATA_COUNT_FAIL",
};
export default dataTypes;
